export default {
    name: 'retaking-history',
    props: {
        history: {
            required: true,
            type: Array
        }
    }
};
